import React, { CSSProperties } from "react";
import IframeResizer from "@iframe-resizer/react";

interface Props {
  data: {
    url: string;
  };
  style?: CSSProperties | undefined;
}

const IframeDisplayComponent: React.FC<Props> = React.memo(({ data, style }) => {
  return (
    <IframeResizer
      license="GPLv3"
      src={data?.url}
      checkOrigin={false}
      style={{ width: "100%", height: "100vh", border: "none", ...style }}
      // @ts-ignore
      waitForLoad={true}
    />
  );
});

export default IframeDisplayComponent;
